import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
var i18n = new VueI18n({
  messages: {
    ch:require('../../static/js/ch'),
    en:require('../../static/js/en')
  }

})

export default i18n;


// WEBPACK FOOTER //
// ./src/common/i18n.js